import React from 'react'
import './custom-alert.scss'

export type CustomAlertType = 'error' | 'warning' | 'success'

interface CustomAlertProps {
    type: CustomAlertType
    message: string
    darkMode?: boolean
    className?: string
}

export const CustomAlert: React.FC<CustomAlertProps> = ({ type, message, darkMode = false, className = '' }) => {
    let icon, colorClass
    switch (type) {
        case 'error':
            icon = <span className="custom-alert-icon">&#9888;</span> // red exclamation
            colorClass = 'custom-alert-error'
            break
        case 'warning':
            icon = <span className="custom-alert-icon">&#x26A0;</span> // yellow warning
            colorClass = 'custom-alert-warning'
            break
        case 'success':
            icon = <span className="custom-alert-icon">&#10003;</span> // green check
            colorClass = 'custom-alert-success'
            break
        default:
            colorClass = ''
    }
    
    const renderMessage = () => {
        if (!message.includes('\n')) return message;
        
        return message.split('\n').map((line, index, array) => (
            <React.Fragment key={index}>
                {line}
                {index < array.length - 1 && <br />}
            </React.Fragment>
        ));
    };
    
    return (
        <div className={`custom-alert ${colorClass} ${darkMode ? 'dark-mode' : ''} ${className}`.trim()}>
            {icon}
            <span className="custom-alert-message">{renderMessage()}</span>
        </div>
    )
}
